var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4577_18514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8 24.8 32 16 32C7.2 32 0 24.8 0 16C0 7.2 7.2 0 16 0C24.8 0 32 7.2 32 16Z",
    fill: "#ED8103"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6 28.8C24.8 28.9 23.9 29 23 29C14.2 29 7 21.8 7 13C7 7.8 9.5 3.1 13.4 0.199997C5.8 1.5 0 8.1 0 16C0 24.8 7.2 32 16 32C19.6 32 22.9 30.8 25.6 28.8Z",
    fill: "#DE7B07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7 21.6V21.8C22.7 21.9 22.7 22.1 22.6 22.2L22.5 22.4C22.4 22.5 22.3 22.6 22.2 22.7L18.6 26.3C18.3 26.6 17.9 26.7 17.6 26.7C17.3 26.7 16.9 26.6 16.6 26.3C16.3 26 16.2 25.7 16.2 25.3C16.2 24.9 16.3 24.5 16.6 24.3L17.7 23.2H11.6C8.8 23.2 6.5 20.9 6.5 18.1V16.9C6.5 16.1 7.1 15.4 8 15.4C8.8 15.4 9.4 16.1 9.4 16.9V18.1C9.4 19.3 10.4 20.3 11.6 20.3H17.7L16.6 19.2C16.3 18.9 16.2 18.6 16.2 18.2C16.2 17.8 16.3 17.4 16.6 17.2C17.1 16.7 18.1 16.7 18.7 17.2L22.4 20.9C22.5 21 22.6 21.2 22.6 21.3C22.7 21.3 22.7 21.5 22.7 21.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4 13.9V15.1C25.4 15.9 24.8 16.5 23.9 16.5C23.1 16.5 22.5 15.9 22.5 15.1V13.9C22.5 12.7 21.5 11.7 20.3 11.7H14.2L15.3 12.8C15.9 13.4 15.9 14.3 15.3 14.9C14.7 15.5 13.8 15.5 13.2 14.9L9.60001 11.3C9.50001 11.2 9.40001 11 9.30001 10.8C9.20001 10.7 9.20001 10.5 9.20001 10.4V10.2C9.20001 10.1 9.20001 9.9 9.30001 9.8V9.7C9.30001 9.5 9.50001 9.4 9.60001 9.2L13.2 5.6C13.8 5 14.7 5 15.3 5.6C15.6 5.9 15.7 6.2 15.7 6.6C15.7 7 15.6 7.4 15.3 7.6L14.2 8.7H20.3C23.2 8.8 25.4 11.1 25.4 13.9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4577_18514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.a44317345fb46da1ec66e69a3414d4a2.svg";
export { ForwardRef as ReactComponent };